<template>
  <div>
    <a-modal
      title="找回密码"
      :visible="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
      cancelText="取消"
      okText="确定"
      @cancel="handleCancel"
    ></a-modal>
  </div>
</template>
<script>
export default {
  name: "forgot",
  props: ["visible"],
  data() {
    return {
      confirmLoading: false
    };
  },
  methods: {
    handleOk() {},
    handleCancel() {
      this.$emit("update", false);
    }
  }
};
</script>

<style>
</style>